import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportSpendMutation,
  ExportSpendMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportSpend = graphql(`
  mutation exportSpend($request: SpendExportRequest!, $exportFormat: ExportFormatArgs!) {
    exportSpend(SpendExportRequest: $request, ExportFormat: $exportFormat) {
      id
    }
  }
`);

/**
 * Kicks off an async spend export via the shared file-export subsystem.
 * Returns `{ id }`; pair with `useFileExport` to subscribe to the export
 * status and download the file.
 */
export function useExportSpend(
  options?: UseMutationOptions<ExportSpendMutation, unknown, ExportSpendMutationVariables, unknown>,
) {
  const { data, ...rest } = useGraphQlMutation(exportSpend, options);
  return { ...rest, data: data?.exportSpend };
}
